import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { CarrierDriverListComponent } from "./carrier-driver-list.component";
import { BusyModule } from "app/busy/busy.module";
import { CarrierDriverAddModule } from "../carrier-driver-add/carrier-driver-add.module";
import { CarrierDriverDetailsModule } from "../carrier-driver-details/carrier-driver-details.module";
import { NgxLoadingModule } from "ngx-loading";

const routes: Routes = [
  // { path: '', component: CarrierDriverListComponent }
];

@NgModule({
  declarations: [CarrierDriverListComponent],
  imports: [
    CommonModule,
    RouterModule,
    CarrierDriverAddModule,
    CarrierDriverDetailsModule,
    // RouterModule.forChild(routes)
    NgxLoadingModule.forRoot({}),
  ],
  exports: [CarrierDriverListComponent],
})
export class CarrierDriverListModule {}
